import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'
import * as PasswordLostData from '../Entities/PasswordLostData'

export function submit(data: PasswordLostData.M): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/password-lost`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(data),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PasswordLostResource.ts